import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { DUPLICATE_CLIENTS_FAILURE, DUPLICATE_CLIENTS_REQUEST, DUPLICATE_CLIENTS_SUCCESS, MERGE_CLIENT_FAILURE, MERGE_CLIENT_REQUEST, MERGE_CLIENT_SUCCESS } from 'mergeClients/constants';

export function getAllExactClientList(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/client/duplicates/`,
      authenticated: true,
      types: [DUPLICATE_CLIENTS_REQUEST, DUPLICATE_CLIENTS_SUCCESS, DUPLICATE_CLIENTS_FAILURE],
      params: { method: 'GET', salonId },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
}

export function mergeClient(salonId, duplicateClients) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/client/merge/`,
      authenticated: true,
      types: [MERGE_CLIENT_REQUEST, MERGE_CLIENT_SUCCESS, MERGE_CLIENT_FAILURE],
      params: { method: 'POST', salonId, duplicateClients },
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(duplicateClients),
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
}
